import { render, staticRenderFns } from "./Redcross.vue?vue&type=template&id=7e23afcb&"
import script from "./Redcross.vue?vue&type=script&lang=js&"
export * from "./Redcross.vue?vue&type=script&lang=js&"
import style0 from "./Redcross.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports